module.exports = __webpack_public_path__ + "static/media/planets.54b2a4a2.svg";